import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import QueryErrorFallback from './QueryErrorFallback'

interface QueryErrorBoundaryProps {
    children: ReactNode
    resetKeys: unknown[]
}

const QueryErrorBoundary = ({ children, resetKeys }: QueryErrorBoundaryProps) => {
    return (
        <QueryErrorResetBoundary>
            {({ reset }) => (
                <ErrorBoundary onReset={reset} resetKeys={resetKeys} FallbackComponent={QueryErrorFallback}>
                    {children}
                </ErrorBoundary>
            )}
        </QueryErrorResetBoundary>
    )
}

export default QueryErrorBoundary
